export default __webpack_public_path__ + "static/media/about1.9f8b9779.png";